module.exports = __webpack_public_path__ + "static/media/icon4.199fbd79.svg";